export const handleImport = (importPromise) =>
  new Promise((resolve, reject) => {
    importPromise
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
